import { useEffect, useState } from 'react';
import { adminApi } from '../../api/adminApi';

export default function GalleryAdmin() {
  const [photoUrl, setPhotoUrl] = useState('');
  const [images, setImages] = useState<any[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  // --- Стан для кастомного модального вікна ---
  const [modal, setModal] = useState<{
    show: boolean;
    title: string;
    message: string;
    onConfirm?: () => void;
    isConfirm?: boolean;
  }>({ show: false, title: '', message: '' });

  const showAlert = (title: string, message: string) => {
    setModal({ show: true, title, message, isConfirm: false });
  };

  const showConfirm = (title: string, message: string, onConfirm: () => void) => {
    setModal({ show: true, title, message, onConfirm, isConfirm: true });
  };

  const closeModal = () => setModal(prev => ({ ...prev, show: false }));
  // -------------------------------------------

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const load = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/gallery`, {
        credentials: 'include'
      });
      if (res.ok) {
        setImages(await res.json());
      }
    } catch (err) {
      console.error('Помилка завантаження галереї');
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    setIsUploading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/upload`, {
        method: 'POST',
        body: formData,
        credentials: 'include'
      });
      const data = await res.json();
      if (data.url) {
        setPhotoUrl(data.url);
      }
    } catch (err) {
      showAlert('Помилка', 'Не вдалося завантажити файл');
    } finally {
      setIsUploading(false);
    }
  };

  const submit = async () => {
    if (!photoUrl) return showAlert('Увага', 'Спочатку завантажте фото!');
    try {
      await adminApi.createImage({ image_url: photoUrl });
      setPhotoUrl('');
      showAlert('Успіх', 'Фото додано до галереї!');
      load();
    } catch (e) {
      showAlert('Помилка', 'Помилка при додаванні зображення в базу');
    }
  };

  const remove = async (id: number) => {
    showConfirm('Видалення', 'Видалити це зображення з галереї?', async () => {
      try {
        await adminApi.deleteImage(id);
        load();
      } catch {
        showAlert('Помилка', 'Помилка при видаленні');
      }
    });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const currentImages = images.slice(indexOfLastItem - itemsPerPage, indexOfLastItem);
  const totalPages = Math.ceil(images.length / itemsPerPage);

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Montserrat, sans-serif', backgroundColor: '#f0f7f4', minHeight: '100vh' }}>
      
      {/* КАСТОМНЕ МОДАЛЬНЕ ВІКНО */}
      {modal.show && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h4 style={{ marginTop: 0, color: '#2d5a50' }}>{modal.title}</h4>
            <p style={{ color: '#666', fontSize: '15px', marginBottom: '25px' }}>{modal.message}</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              {modal.isConfirm && (
                <button onClick={closeModal} style={modalSecondaryBtnStyle}>Скасувати</button>
              )}
              <button 
                onClick={() => { modal.onConfirm?.(); closeModal(); }} 
                style={modalPrimaryBtnStyle}
              >
                ОК
              </button>
            </div>
          </div>
        </div>
      )}

      <h2 style={{ textAlign: 'center', color: '#2d5a50', marginBottom: '30px' }}>🖼 Керування галереєю</h2>

      {/* ФОРМА ДОДАВАННЯ */}
      <div style={{ background: '#fff', padding: '25px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '40px' }}>
        <h3 style={{ marginTop: 0, fontSize: '18px', marginBottom: '15px' }}> Додати нове фото</h3>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: '250px' }}>
            <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '5px' }}>Оберіть файл зображення:</label>
            <input type="file" accept="image/*" onChange={handleFileUpload} style={inputStyle} />
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '150px' }}>
            {isUploading && <span style={{ fontSize: '14px', color: '#1abc9c', marginBottom: '5px' }}>⏳ Завантаження...</span>}
            {photoUrl && <span style={{ fontSize: '14px', color: '#28a745', marginBottom: '5px' }}>✅ Файл готовий</span>}
            <button 
              onClick={submit} 
              disabled={!photoUrl || isUploading}
              style={{ 
                ...buttonStyle, 
                opacity: (!photoUrl || isUploading) ? 0.6 : 1,
                cursor: (!photoUrl || isUploading) ? 'not-allowed' : 'pointer'
              }}
            >
              Зберегти в галерею
            </button>
          </div>
        </div>
      </div>

      {/* СІТКА ЗОБРАЖЕНЬ */}
      <h3 style={{ marginBottom: '20px' }}>📋 Поточні фото ({images.length})</h3>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
        gap: '20px' 
      }}>
        {currentImages.map(img => (
          <div key={img.id} style={galleryCardStyle}>
            <div style={imageWrapperStyle}>
              <img src={img.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div style={overlayStyle}>
                <button onClick={() => remove(img.id)} style={deleteBtnSmallStyle}>Видалити ❌</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ПАГІНАЦІЯ */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '40px' }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => { setCurrentPage(i + 1); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              style={{
                width: '35px', height: '35px', borderRadius: '6px', border: '1px solid #ddd',
                backgroundColor: currentPage === i + 1 ? '#1abc9c' : '#fff',
                color: currentPage === i + 1 ? '#fff' : '#333',
                cursor: 'pointer', fontWeight: 'bold'
              }}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// --- Стилі Модального Вікна ---
const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
  justifyContent: 'center', alignItems: 'center', zIndex: 1000,
  backdropFilter: 'blur(2px)'
};

const modalContentStyle: React.CSSProperties = {
  background: '#fff', padding: '30px', borderRadius: '15px',
  maxWidth: '400px', width: '90%', boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
  textAlign: 'center'
};

const modalPrimaryBtnStyle = {
  padding: '10px 25px', background: '#1abc9c', color: '#fff',
  border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' as const
};

const modalSecondaryBtnStyle = {
  padding: '10px 25px', background: '#eee', color: '#333',
  border: 'none', borderRadius: '8px', cursor: 'pointer'
};

// --- Основні стилі ---
const inputStyle = { 
  padding: '10px', 
  borderRadius: '8px', 
  border: '1px solid #ddd', 
  fontSize: '14px', 
  width: '100%',
  background: '#fff',
  outline: 'none'
};

const buttonStyle = { 
  padding: '12px 20px', 
  backgroundColor: '#1abc9c', 
  color: '#fff', 
  border: 'none', 
  borderRadius: '8px', 
  fontWeight: 'bold' as const,
  transition: 'background 0.2s'
};

const galleryCardStyle = {
  background: '#fff',
  borderRadius: '12px',
  border: '1px solid #eee',
  padding: '8px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  position: 'relative' as const
};

const imageWrapperStyle = {
  width: '100%',
  height: '180px',
  borderRadius: '8px',
  overflow: 'hidden' as const,
  position: 'relative' as const,
  backgroundColor: '#f0f7f4'
};

const overlayStyle = {
  position: 'absolute' as const,
  bottom: 0, left: 0, right: 0,
  padding: '8px',
  background: 'rgba(255,255,255,0.9)',
  display: 'flex',
  justifyContent: 'center'
};

const deleteBtnSmallStyle = {
  background: 'none',
  border: 'none',
  color: '#dc3545',
  fontSize: '12px',
  cursor: 'pointer',
  fontWeight: 'bold' as const
};